import React, { useState, useEffect, useCallback } from "react";
import "./Vendorbanner.css";
import bannerimge from "../pages/modules/banner.jpg";

// Import section components (make sure these exist in your project)
import Aboutmaamaas from "../Tablemenu/Aboutmaamaas.js";
import LeadershipCard from "../Tablemenu/LeadershipCard.js";

import { FaInstagram, FaYoutube, FaLinkedin, FaFacebook, FaTwitter } from "react-icons/fa";

const CompanyBanner = () => {
  const [companyData, setCompanyData] = useState({
    name: "Maamaas Kitchen",
    since: "2026",
    banner: bannerimge,
    logo: "https://cdn-icons-png.flaticon.com/512/2921/2921822.png",
    openTime: "09:00 AM",
    closeTime: "10:00 PM",
    social: {
      instagram: "",
      youtube: "",
      linkedin: "",
      facebook: "",
      twitter: ""
    }
  });

  // State for controlling if sections are visible
  const [showSections, setShowSections] = useState(false);

  // Fetch banner data from API (display only - no edit)
  const fetchBannerData = useCallback(async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId || !token) return;

    try {
      const res = await fetch(
        `https://backend.maamaas.com/food/api/banner/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (!res.ok) return;

      const data = await res.json();

      setCompanyData(prev => ({
        ...prev,
        name: data.companyName || prev.name,
        since: data.establishedYear || prev.since,
        banner: data.companyBanner || prev.banner,
        logo: data.companyLogo || prev.logo,
        social: {
          ...prev.social,
          instagram: data.instagramLink || "",
          youtube: data.youtubeLink || "",
          linkedin: data.linkedinLink || "",
          facebook: data.facebookLink || "",
          twitter: data.twitterLink || ""
        }
      }));
    } catch (err) {
      console.error("Banner fetch error", err);
    }
  }, []);

  useEffect(() => {
    fetchBannerData();
  }, [fetchBannerData]);

  // Toggle sections visibility and scroll
  const toggleSections = () => {
    setShowSections(!showSections);
    
    // If we're showing sections (not hiding), scroll to About section
    if (!showSections) {
      setTimeout(() => {
        const element = document.getElementById("about-section");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  };

  return (
    <>
      {/* BANNER SECTION */}
      <div className="company-banner-wrapper">
        <div
          className="banner"
          style={{ backgroundImage: `url(${companyData.banner})` }}
        >
          <div className="banner-overlay">
            <div className="banner-left">
              <img
                src={companyData.logo}
                alt="logo"
                className="company-logo"
              />
              <div className="company-info">
                <h2>{companyData.name}</h2>
                <p>Since {companyData.since}</p>
              </div>
            </div>
            <div className="info-actions">
              <div className="time-badge">
                <span className="status-dot"></span>
                Open • {companyData.openTime} - {companyData.closeTime}
              </div>
            </div>
          </div>

          {/* BOTTOM SECTION WITH SOCIAL ICONS AND SINGLE KNOW MORE BUTTON */}
          <div className="banner-bottom">
            <div className="banner-social">
              <a
                href={companyData.social.instagram || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.instagram ? "disabled" : ""}
              >
                <FaInstagram />
              </a>
              <a
                href={companyData.social.youtube || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.youtube ? "disabled" : ""}
              >
                <FaYoutube />
              </a>
              <a
                href={companyData.social.linkedin || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.linkedin ? "disabled" : ""}
              >
                <FaLinkedin />
              </a>
              <a
                href={companyData.social.facebook || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.facebook ? "disabled" : ""}
              >
                <FaFacebook />
              </a>
              <a
                href={companyData.social.twitter || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.twitter ? "disabled" : ""}
              >
                <FaTwitter />
              </a>
            </div>
            
            {/* SINGLE KNOW MORE BUTTON */}
            <button 
              className="know-more-nav-btn"
              onClick={toggleSections}
            >
              {showSections ? "Show Less" : "Know More"}
            </button>
          </div>
        </div>
      </div>

      {/* ABOUT SECTION - Shows/Hides based on button click */}
      {showSections && (
        <>
          <div id="about-section" className="section-wrapper">
            <div className="section-header">
              <h3>About Us</h3>
            </div>
            <div className="section-content expanded">
              <Aboutmaamaas />
            </div>
          </div>

          {/* LEADERSHIP SECTION */}
          <div id="leadership-section" className="section-wrapper">
            <div className="section-header">
              <h3>Our Leadership</h3>
            </div>
            <div className="section-content expanded">
              <LeadershipCard />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CompanyBanner;